const hasTimer = document.querySelector('.countdown-timer');

const timer = () => {
	const countdownDateTime = `${countdownDate} ${countdownTime}`;
	const finalDate = new Date(countdownDateTime).getTime();
	const now = new Date().getTime();
	let diff = finalDate - now;

	if (diff < 0) {
		let cdTimerAlert = document.querySelector('.countdown-timer-alert');
		let cdTimer = document.querySelector('.countdown-timer');
		let cdHeader = document.querySelector('.w-countdown-header');

		if (cdTimerAlert) {
			cdTimerAlert.style.display = 'block';
		}

		if (cdHeader) {
			cdHeader.innerHTML = blWebinarHeader;
		}

		cdTimer.style.display = 'none';
	}

	let days = Math.floor(diff / (1000 * 60 * 60 * 24));
	let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

	days <= 99 ? days = `${days}` : days;
	days <= 9 ? days = `${days}` : days;
	hours <= 9 ? hours = `0${hours}` : hours;
	minutes <= 9 ? minutes = `0${minutes}` : minutes;

	document.querySelector('#days').textContent = days;
	document.querySelector('#hours').textContent = hours;
	document.querySelector('#minutes').textContent = minutes;
}

if (hasTimer) {
	timer();
	setInterval(timer, 60000); // Update every minute (60,000 milliseconds)
}
